export default __webpack_public_path__ + "static/media/snowflake.ca38e822.png";